import { Box, Typography } from '@mui/material';

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: number;
  boxPaddingTop?: number;
  className?: string;
}

export const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, boxPaddingTop = 2, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`standard-tab-${index}`}
      aria-labelledby={`standard-tab-${index}`}
      {...other}>
      {value === index && (
        <Box sx={{ pt: boxPaddingTop }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
};
